// Demo-account gating. The accounts listed here see the curated v6 mock yard
// (12 horses, Hollow Tree Livery) on every protected screen. Everyone else
// gets a clean empty state until Phase 1 wires Firestore properly.
//
// Keep this list small. Add via Firebase Auth email (case-insensitive).

const DEMO_EMAILS = new Set<string>([
  "jackburbridge72@gmail.com",
]);

export function isDemoEmail(email: string | null | undefined): boolean {
  return !!email && DEMO_EMAILS.has(email.toLowerCase());
}
